import React from 'react'


const ThankYou = () => {


    return (<div className="container">
        <div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label className="heading">Request a Quote</label>
                <label className="heading" style={{ fontSize: '18px', marginTop: '50px' }}>Your Quote Request has been successfully submitted!</label>
                <label className="question" style={{ marginTop: '20px', fontSize: '16px', fontWeight: '400' }}>A confirmation has been sent to your email address.</label>
                <label className="question" style={{ marginTop: '0px', fontSize: '16px', fontWeight: '400' }}> <a href='https://mobilityaccess.com.au/contact-us-service-area/' target='_blank'>Contact us</a> if you have any questions or need any assistance with your request.</label>
                <label className="question" style={{ marginTop: '0px', fontSize: '16px', fontWeight: '400' }}>Thank you!</label>
            </div>
        </div>
    </div>)
}

export default ThankYou